var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"ma-0 pa-1",attrs:{"height":"20","hide-details":"","value":_vm.preLoadFiltro(_vm.value)},on:{"input":(event)=>_vm.$emit('input', _vm.preUpdateFiltro(event))}})
}
var staticRenderFns = []

export { render, staticRenderFns }